export const CONVERSATION_FILTERS = ['Cohort', 'Leaderboard'] as const;
